import PropTypes from 'prop-types';
import React from 'react';
import Ad from '../common/ad';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import { scrollAdPosition } from '../../utils/ads/positionStrings';
import { ARTICLE_FULL_WIDTH_PAGE_TYPE } from '../../constants';
import classnames from 'classnames';

const RELATED_CONTENT_MODULE_TYPE = 'related-content';

const getUniqueIdPrefix = (moduleType) =>
  moduleType === RELATED_CONTENT_MODULE_TYPE
    ? 'related-content-row-'
    : 'feed-row-';

const getUniqueId = (moduleType, rowID) =>
  getUniqueIdPrefix(moduleType) + rowID;

const isFullWidthArticle = (type) =>
  type === ARTICLE_FULL_WIDTH_PAGE_TYPE;

const RowAd = ({
  adPosition,
  adsState,
  adSizes,
  moduleType,
  rowID,
  page_type
}) => (
  <div className={classnames('row row-ad', getUniqueId(moduleType, rowID))}>
    <RosettaFormattedMessage parentFilename={__filename}
      id="ad"
      description="Copy for Row Ads"
      defaultMessage="Advertisement"
    />
    <Ad adsState={adsState}
      sizes={adSizes}
      position={adPosition}
      onFullWidthArticle={isFullWidthArticle(page_type)}
      scrollAdPosition={scrollAdPosition(adPosition)}
      uniqueId={getUniqueId(moduleType, rowID)}
    />
  </div>
);

RowAd.propTypes = {
  adsState: PropTypes.object.isRequired,
  adPosition: PropTypes.string,
  adSizes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  moduleType: PropTypes.string.isRequired,
  rowID: PropTypes.number.isRequired,
  page_type: PropTypes.string.isRequired
};

export default RowAd;
